import { ArrowRight } from "lucide-react"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { Dropdown } from "./user-profile"
import { Modal } from "@/shared/components"
import { invalidate } from "@/shared/utils"
import { Badge } from "@/shared/components/common/Badge"
import { Notification03 } from "@/shared/components/ui/icons"
import { useFileDownload } from "@/shared/api/use-file-download"
import { CustomIconButton } from "@/shared/ui/custom-icon-button"
import { DownloadableFile } from "@/shared/components/common/DownloadableFile"
import { useFetchMyNotifications } from "@/entities/notification/api/fetch-notifications"
import { IInspectEnergyAuditNotificationItem } from "@/entities/notification/model/types"
import { useMarkAsReadNotification } from "@/entities/notification/api/mark-as-read-notifications"

export const AppNotifications = () => {
  const [notification, setNotification] = useState<IInspectEnergyAuditNotificationItem | undefined>(undefined)

  const { downloadFile } = useFileDownload()
  const { t } = useTranslation()

  const { data: notifications } = useFetchMyNotifications()
  const { mutate: markAsRead } = useMarkAsReadNotification()
  const results = notifications?.results ?? []

  const handleReadNotification = (notificationn: IInspectEnergyAuditNotificationItem) => {
    setNotification(notificationn)
  }

  useEffect(() => {
    if (notification) {
      markAsRead(notification.id, {
        onSuccess: () => {
          invalidate(["myNotifications"])
        }
      })
    }
  }, [notification])

  return (
    <>
      <Dropdown
        label={
          <CustomIconButton>
            <Badge exist={results.filter(n => !n.is_read).length > 0}>
              <Notification03 size={20} className="text-icon-color" />
            </Badge>
          </CustomIconButton>
        }
      >
        <div className="p-4 max-w-lg">
          {notifications?.results &&
            (results.length === 0 ? (
              <div>{t("no_notifications")}</div>
            ) : (
              results.map(notification => (
                <NotificationItem key={notification.id} notification={notification} onOpen={() => handleReadNotification(notification)} />
              ))
            ))}
        </div>
      </Dropdown>
      {notification && (
        <Modal show={!!notification} onClose={() => setNotification(undefined)} title={t("notification_details")}>
          <div className="">{notification?.message}</div>
          {notification.file && (
            <DownloadableFile
              fileName="file"
              onDownload={() => {
                downloadFile(notification.file)
              }}
            />
          )}
        </Modal>
      )}
    </>
  )
}

const NotificationItem = ({ notification, onOpen }: { notification: IInspectEnergyAuditNotificationItem; onOpen: () => void }) => {
  return (
    <button
      type="button"
      onClick={onOpen}
      key={notification.id}
      className={
        "w-full overflow-hidden flex justify-between items-center gap-2 cursor-pointer text-sm" +
        (notification.is_read ? " opacity-50" : " font-medium")
      }
    >
      <span className="truncate">
        {notification?.message} Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur blanditiis voluptatem inventore quisquam
        reiciendis placeat, officiis eaque eius iste quas odit tenetur minus? Corporis facere vitae accusantium aliquid delectus. Corrupti!
      </span>
      <ArrowRight className="text-gray-500" />
    </button>
  )
}
